import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import Modal from 'react-bootstrap/Modal'
import { API_BASE_URL } from '../../config';
import { connect } from 'react-redux'
const ApplyJob = (props) => {
    const [state, setState] = useState({
        Salary: "",
        Noticep: '',
        error: { name: '', message: '' }, loader: false,
    })
    useEffect(() => {
        setState((prev) => ({ ...prev, Salary: '', Noticep: '', error: { name: '', message: '' }, loader: false }))
        if(props.show){
            document.body.classList.add("showModal")
        }
    }, [props.show])
    const handleSubmitClick = async (e) => {
        e.preventDefault();
        if (state.Noticep === "") {
            setState((prev) => ({ ...prev, error: { name: "Noticep", message: 'Please enter Notice Period' } }))
        } else {
            if (state.Salary === "") {
                setState((prev) => ({ ...prev, error: { name: "Salary", message: 'Please enter Expected Salary' } }))
            } else {
                await setState((prev) => ({ ...prev, loader: true }))
                var data = new FormData();
                data.append("action", "apply_job")
                data.append("u_id", props.loginData.user_id)
                data.append("j_id", props.detail.c_id)
                data.append("c_id", props.detail.c_id)
                data.append("notice_period", state.Noticep)
                data.append("exp_salary", state.Salary)
                const requestOptions = {
                    method: 'post',
                    body: data
                };
                fetch(API_BASE_URL + 'data_process.php', requestOptions)
                    .then((response) => response.json())
                    .then(async (responseJson) => {
                        await setState((prev) => ({ ...prev, loader: false }))
                        await document.body.classList.remove("showModal");
                        props.handleResponce(responseJson)
                    })
                    .catch((error) => { });
            }
        }
    }
    const handleChange = (e) => {
        setState(prevState => ({ ...prevState, error: { name: '', message: '' } }))
        const { name, value } = e.target
        setState(prevState => ({ ...prevState, [name]: value }))
    }
    return (
        <div class={props.show ? "jblListModal modalHere" : "jblListModal"}>
            <div class="jblListModal_Content" style={{ "padding": "15px", "height": 'auto' }}>
                <div class="jblListModal_header">
                    <span class="close" onClick={() =>{document.body.classList.remove("showModal"); props.handleClose()}}>&times;</span>
                </div>
                <div class="jblListModal_Body">
                    <h3>Apply for job</h3>
                    <div class="form_wrapper" style={{"border": "0px","padding": "0px","width": "100%","margin": "0px","box-shadow": "none"}} >
                        <div class="form_container">
                            <form>
                                <div class="input_field">
                                    <label class="txt_title">Notice Period*</label>
                                    <input type="text" name="Noticep" value={state.Noticep}
                                        onChange={handleChange} />
                                    <p className={"errormessage"}>{(state.error.name === "Noticep") && state.error.message}</p>
                                </div>
                                <div class="input_field">
                                    <label class="txt_title">Expected Salary(Year)*</label>
                                    <input type="number" name="Salary" value={state.Salary}
                                        onChange={handleChange} />
                                    <p className={"errormessage"}>{(state.error.name === "Salary") && state.error.message}</p>
                                </div>
                                <div class="siteBtn_box">
                                    <input class="button" type="submit" value="Submit" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                </div>
                <div class={props.show? "modal-backdrop fade show" : "modal-backdrop fade"}  onClick={() => {document.body.classList.remove("showModal");props.handleClose()}}></div>
        </div>
    )
}
const mapStateToProps = (state) => { return { loginData: state.list.login }; };
export default connect(mapStateToProps)(withRouter(ApplyJob));
